<nz-card [ngClass]="{'active': isActive}" [nzHoverable]="!isAlert">
  <div [ngClass]="(isMobile$ | async) ? 'justify-space-between' : 'flex-center-between'" class="no-wrap gap-100" style="margin-bottom: 8px;overflow: hidden;">
    <div [style.justify-content]="(isMobile$ | async) ? 'space-between' : 'start'" style="min-width: 0;flex: 0 0 50%;" class="filters-container flex-center">
      <label *ngIf="checkboxConfig.show" nz-checkbox (nzCheckedChange)="checkboxChange()"
             [nzChecked]="checkboxConfig.isChecked"
             (click)="$event.stopPropagation()"></label>
      <div class="flex-center" style="overflow: hidden">
        <app-st-icon *ngIf="icon" [avatar]="true" [name]="icon"></app-st-icon>
        <span class="text-label-14 text-semibold text-dark text-nowrap" style="text-overflow: ellipsis;">{{ name }}</span>
        @if (showStateBadge) {
          <!-- Si hay flowEvents, usar serviceOrderState pipe, sino usar projectState pipe -->
          <ng-container *ngIf="flowEvents && state && (state | serviceOrderState:flowEvents) as stateData">
            <span class="st-badget"
                  [ngClass]="[ stateData.class, ((isMobile$ | async) ? 'small' : '') ]">
              <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
              <label>{{ stateData.name }}</label>
            </span>
          </ng-container>
          <ng-container *ngIf="!flowEvents && state && (state | projectState) as stateData">
            <span class="st-badget"
                  [ngClass]="[ stateData.class, ((isMobile$ | async) ? 'small' : '') ]">
              <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
              <label>{{ stateData.name }}</label>
            </span>
          </ng-container>
          <span *ngIf="showStateBadge && !state" class="st-badget subtle-grey"
                [ngClass]="((isMobile$ | async) ? 'small' : '')">
            <label>Sin estado</label>
          </span>
        }
      </div>

      <ng-container *ngIf="!(isMobile$ | async)" [ngTemplateOutlet]="ordersTmpl"></ng-container>

    </div>
    <div class="flex gap-100" style="flex: 0 0 50%; justify-content: flex-end; box-sizing: border-box; overflow: hidden; white-space: nowrap; max-width: 50%;">
      <ng-container *ngIf="assignedTo && !(isMobile$ | async)" [ngTemplateOutlet]="assignedToTmpl"></ng-container>
      <ng-container *ngIf="showServiceMenu && !(isMobile$ | async)" [ngTemplateOutlet]="serviceMenuTmpl"></ng-container>
    </div>
    <app-st-icon *ngIf="isAlert" style="font-size: 20px"
                 class="cursor-pointer"
                 nz-tooltip="Este servicio no posee un Flujo y no se puede interactuar con el mismo."
                 [color]="'#CB2A2F'" [filled]="true" [bold]="true" [name]="'error'"></app-st-icon>
  </div>
  <div class="flex wrap btm-data">
    <div class="flex" style="max-width: 100%">
      <div *ngIf="origin" class="flex-center gap-075 btm-data-item"  [ngStyle]="{ 'max-width': destination ? '50%' : '100%' }"
           [ngClass]="(isMobile$ | async) ? 'text-label-12' : 'text-label-14'">
        <app-st-icon [name]="(origin.locationTypeId != null ? (origin.locationTypeId | placeIcon) : 'location_on')"></app-st-icon>
        <label class="text-nowrap">{{ origin.name || 'Sin ubicación' }}</label>
      </div>
      @if (destination) {
        <app-st-icon [bold]="true" name="arrow_forward"></app-st-icon>
        <div class="flex-center gap-075 btm-data-item" [ngStyle]="{ 'max-width': origin ? '50%' : '100%' }"
             [ngClass]="(isMobile$ | async) ? 'text-label-12' : 'text-label-14'">
          <app-st-icon [name]="(destination.locationTypeId != null ? (destination.locationTypeId | placeIcon) : 'location_on')"></app-st-icon>
          <label class="text-nowrap">{{ destination.name || 'Sin ubicación' }}</label>
        </div>
      }
    </div>
  </div>
  <div style="margin-top: 7px" class="flex-center-between orders-providers-wrapper" *ngIf="(isMobile$ | async)">
    <ng-container [ngTemplateOutlet]="ordersTmpl"></ng-container>
    <ng-container [ngTemplateOutlet]="providerTmpl"></ng-container>
  </div>
</nz-card>

<ng-template #actionBtnsTmpl>
  <app-action-btns
    [copy]="actions.copy"
    [file]="actions.file"
    [message]="actions.message"
    [drawer]="actions.drawer"
    (buttonClick)="onAction($event)"
  ></app-action-btns>
</ng-template>

<ng-template #ordersTmpl>
  <div class="flex-center gap-050 no-wrap" *ngIf="totalOrders && completedOrders !== undefined">
    <!--    <nz-progress nzType="circle"-->
    <!--                 [nzWidth]="12"-->
    <!--                 [nzStrokeWidth]="10"-->
    <!--                 [nzShowInfo]="false"-->
    <!--                 [nzPercent]="percent"-->
    <!--                 [nzStatus]="progressStatus">-->
    <!--    ></nz-progress>-->

    <span class="text-label-12 text-semibold text-nowrap" style="margin-left: 8px;">
      <span hidden class="text-dark">{{ completedOrders }} / </span> {{ totalOrders }} {{ totalOrders === 1 ? 'Tarea' : 'Tareas' }}
    </span>
  </div>
</ng-template>


<ng-template #assignedToTmpl>
  <div *ngIf="assignedPartner" class="flex-center gap-100">
    <span class="text-label-14 color-grey-9">Asignada a:</span>
    <div class="st-badget subtle-grey assigned-badge flex-center gap-075">
      <nz-avatar
        class="assigned-avatar"
        [nzSize]="20"
        [nzSrc]="assignedPartner.avatar ? getSafeImageUrl(assignedPartner.avatar) : undefined"
        [nzText]="!assignedPartner.avatar ? getInitials(assignedPartner) : undefined"
        [ngStyle]="!assignedPartner.avatar ? {'background-color': '#fff', 'color': '#000'} : {}"
      ></nz-avatar>
      <span class="text-label-14 text-dark">
        ({{ getInitials(assignedPartner) }}) {{ assignedPartner.name || '' }} {{ assignedPartner.surName || '' }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #providerTmpl>
  <div *ngIf="provider" class="flex-center gap-200 provider-container">
    <span *ngIf="!(isMobile$ | async)" class="text-label-14">Proveedor:</span>

    <div class="avatar-badge" style="width: fit-content; max-width: 300px; min-width: 0">
      <nz-avatar
        [nzSize]="24"
        [nzSrc]="getSafeImageUrl(provider.avatar)"
        [nzAlt]="provider.name"
      ></nz-avatar>
      <span class="text-label-12 text-dark text-semibold text-nowrap">
             {{ provider.name }} {{ provider.surName || '' }}
          </span>
    </div>
  </div>
</ng-template>

<ng-template #serviceMenuTmpl>
  <button
    nz-button
    nzType="text"
    nzShape="circle"
    nzSize="default"
    nz-dropdown
    [nzDropdownMenu]="serviceMenu"
    (click)="$event.stopPropagation()"
    class="service-menu-btn"
  >
    <app-st-icon [bold]="true" name="more_vert"></app-st-icon>
  </button>
  <nz-dropdown-menu #serviceMenu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="onServiceMenuClick('edit')">
        <div class="flex-center gap-100">
          <app-st-icon name="edit" [bold]="true"></app-st-icon>
          <span class="text-label-14 text-dark">Editar</span>
        </div>
      </li>
      <li nz-menu-item (click)="onServiceMenuClick('delete')">
        <div class="flex-center gap-100">
          <app-st-icon name="delete" [bold]="true"></app-st-icon>
          <span class="text-label-14 text-dark">Eliminar</span>
        </div>
      </li>
    </ul>
  </nz-dropdown-menu>
</ng-template>

